<template>
  <div>
    <el-row>
      <FuncionalidadeHeader
        v-if="funcData.parametros.textos.confirmarIdentidadeTituloNavegacao"
        :titulo="funcData.parametros.textos.confirmarIdentidadeTituloNavegacao"
        :custom-voltar="true"
        :info="false"
        :login="true"
        @click="$emit('voltar')"
      />
    </el-row>
    <el-row>
      <p
        v-if="funcData.parametros.textos.confirmarIdentidadeCabecalho"
        class="recuperar-cabecalho"
      >
        {{ funcData.parametros.textos.confirmarIdentidadeCabecalho }}
      </p>
    </el-row>
    <el-row v-if="contatos.length">
      <h4>Meus contatos</h4>
      <el-radio-group v-model="selecionado" class="lista-contatos">
        <el-radio
          v-for="(valor, index) in contatos"
          :label="valor"
          :key="index"
        >
          {{ valor.contato }}
        </el-radio>
      </el-radio-group>
      <p
        v-if="funcData.parametros.textos.confirmarIdentidadeRodape"
        class="recuperar-rodapé"
      >
        {{ funcData.parametros.textos.confirmarIdentidadeRodape }}
      </p>
      <AlertaErro
        v-model="erro.show"
        :title="erro.titulo"
        :description="erro.descricao"
      />
      <ButtonDefault
        :title="funcData.parametros.textos.confirmarIdentidadeBotaoEnviar"
        @click="enviar"
      />
    </el-row>
    <el-row v-else>
      <p>
        <strong>Meus contatos</strong>
      </p>
      <div class="whitoutContact">
        <span>{{ funcData.parametros.textos.recuperarSenhaTextoNenhumContatoEncontrado }}</span>
      </div>
    </el-row>
    <el-row class="text-center" style="margin-top: 25px">
      <ButtonLink
        v-if="funcData.parametros.botaoRecuperarSenhaQuestionarioAtivo"
        :texto="funcData.parametros.textos.botaoRecuperarSenhaQuestionariolabel"
        @click="exibirQuestionario"
      />
    </el-row>
    <ButtonDefault
      v-if="config.configuracaoAcesso.centralDeAjuda.ativo"
      :title="'Central de ajuda'"
      :secundario="true"
    />
  </div>
</template>

<script>
import AlertaErro from '@/components/AlertaError/AlertaErro'
import { mapGetters, mapState } from 'vuex'
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import ButtonDefault from '@/components/buttons/ButtonDefault'
import ButtonLink from '@/components/ButtonLink/ButtonLink'

export default {
  name: 'RecuperarSenhaConfirmar',
  components: {
    FuncionalidadeHeader,
    AlertaErro,
    ButtonDefault,
    ButtonLink
  },
  props: {
    contatos: {
      type: Array,
      default: () => []
    },
    token: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      form: {},
      emptyContacts: true,
      erro: {
        show: false,
        titulo: 'Erro no preenchimento:',
        descricao: ''
      },
      selecionado: null
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState('SetupApp', ['config', 'apiAcesso', 'frameId']),
    ...mapGetters('SetupApp', ['estilo']),
    funcData () {
      return this.config.configuracaoAcesso.recuperarSenha
    }
  },
  methods: {
    async init () {
      // this.contatos = []
    },
    showError () {
      this.erro.descricao = `<ul><li>Selecione um meio de contato</li></ul>`
      this.erro.show = true
    },
    async enviar () {
      this.erro.show = false

      if (!this.selecionado) {
        return this.showError()
      }

      const payload = this.selecionado

      const response = await this.apiAcesso.recuperarSenha.recuperarSenhaConfirmarIdentidade({
        payload,
        loading: true,
        handlerErrorIgnore: true
      })

      if (response.status) {
        this.$emit('submit', this.selecionado)
      } else {
        this.erro.descricao = `<ul><li>${response.message}</li></ul>`
        this.erro.show = true
      }
    },
    voltar () {
      this.$emit('voltar')
    },
    exibirQuestionario () {
      this.$emit('questionario')
    }
  }
}
</script>

<style scoped>
.recuperar-cabecalho {
  letter-spacing: 0;
  color: #333333;
}

.lista-contatos {
  margin: 10px 0 15px;
}

.recuperar-rodapé {
  font: normal normal normal 12px/17px Open Sans;
  letter-spacing: 0;
  color: #333333;
  margin-bottom: 15px;
}

.whitoutContact {
  border-radius: 10px;
  background-color: #F2F2F2;
  padding: 10px;
}
</style>
